import React from 'react';
import { Container, Typography } from '@mui/material';

const OrderDetail = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4">Detalle del Pedido</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Página de detalle del pedido en construcción...
      </Typography>
    </Container>
  );
};

export default OrderDetail; 